import EventsPage from './EventsPage';
import EventsFullView from './EventsFullView';

export {
    EventsPage,
    EventsFullView,
}


// WEBPACK FOOTER //
// src/client/components/site/features/events/pages/index.js